import type { ReactElement } from 'react';
import { useGamesSite } from '@fias/public-site-ui';
import { usePageHead } from '@/lib/document-head';

/**
 * The Games page where its switch is off (an environment it has not been
 * turned on in): nothing about the catalog, and nothing for search engines.
 */
export function GamesUnavailablePage(): ReactElement {
  const { Link } = useGamesSite();
  usePageHead({ title: 'Fias', noindex: true });
  return (
    <div className="fg-wrap">
      <div className="fg-empty fg-empty--page">
        <h1 className="fg-empty__title">This page isn’t available.</h1>
        <p>
          <Link href="/">Go to Fias</Link>
        </p>
      </div>
    </div>
  );
}
